import { workspaceApiUrlPrefix } from '@cores/constants/envConfig';
import _ from 'lodash';
import { getPluginNameByDataType } from './consts';
import { createPsAxiosInstance, Cache } from '@patsnap/common-ps-http';
import { requestConfigWrapper, PersistentCacheConfig, PersistentCacheStrategy } from '@patsnap/common-ps-http/dist/PersistentCache';
const pureAxios = createPsAxiosInstance({}, new Cache());
const persistCacheConfInst = new PersistentCacheConfig({
    strategy: PersistentCacheStrategy.CACHE_FIRST_WITH_SILENT_UPDATE, // 缓存策略，见下表
    detectAllowCachingHook: PersistentCacheConfig.defaults.detectAllowCachingHook_statusdata,
});
export const infoStorgeIndexedByPluginName = new Map();
export async function updateDataSourceInfo() {
    let info;
    try {
        info = await pureAxios.psHttp(requestConfigWrapper({
            method: 'get',
            url: `${workspaceApiUrlPrefix}/datasource/list`,
            headers: {
                'X-API-Version': '2.0',
            },
        }, persistCacheConfInst)).then(res => res.data.data);
    }
    catch (error) {
        console.error('初始化错误：', error);
        const { data } = await import('./datasource_list.json');
        // @ts-ignore 先忽略，mock数据中最终删除无用信息后，是可以满足类型的；
        info = data;
    }
    info.forEach(transInfo => {
        infoStorgeIndexedByPluginName.set(getPluginNameByDataType(transInfo.name), Object.freeze(transInfo));
    });
    return info;
}
function getTargetMessage(localeVal, fullTransInfo) {
    const targetMessage = {
        advanceSort: {},
        ViewDataConfig: {},
    };
    fullTransInfo.forEach(transInfo => {
        const pluginName = getPluginNameByDataType(transInfo.name);
        targetMessage.advanceSort[pluginName] = {
            fields: {},
        };
        transInfo.sort_types.forEach(sortType => {
            targetMessage.advanceSort[pluginName].fields[sortType.name] = sortType?.i18n[localeVal];
        });
        targetMessage.ViewDataConfig[pluginName] = {
            label: transInfo.i18n[localeVal],
        };
        targetMessage[_.camelCase(`common ${pluginName}`)] = {
            BASIC: transInfo.fields?.reduce((acc, field) => {
                acc[field.field_id] = field?.i18n[localeVal];
                return acc;
            }, {}),
        };
    });
    return targetMessage;
}
// 这里会生成一份插件专用的翻译JSON，将合并如主翻译
export async function getPluginTranslations(locale) {
    const info = await updateDataSourceInfo();
    const st = getTargetMessage(locale, info);
    return st;
}
